import { render, staticRenderFns } from "./PropertyContainer.vue?vue&type=template&id=2001f000"
import script from "./PropertyContainer.vue?vue&type=script&lang=ts"
export * from "./PropertyContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports